import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Stepper,
  Step,
  StepLabel,
  Card,
  CardContent,
  Alert,
  Divider,
  Autocomplete,
  Chip,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useResidents } from "../hooks/useResidents";
// Validation schema
const admissionSchema = yup.object({
  // Personal Information
  // firstName: yup.string().required('First Name is required').matches(/^[A-Za-z\s]+$/),
  // middleName: yup.string().required('Middle Name is required').matches(/^[A-Za-z\s]+$/),
  // lastName: yup.string().required('Last Name is required').matches(/^[A-Za-z\s]+$/),
  // dateOfBirth: yup.date().required('Date of birth is required').nullable(),
  // gender: yup.string().required('Gender is required'),
  // address: yup.string().required('Address is required').matches(/^[A-Za-z0-9\s]+$/),
  // roomNumber: yup.string().required('Room number is required'),
  // bedNumber: yup.string().required('Bed number is required'),
  // ssn: yup.string().optional(),
  // admissionType: yup.string().required('Admission type is required'),
  // pcpName: yup.string().required('PCP Name is required'),
  // pcpNPI: yup.string().required('PCP NPI is required'),
  // preferredPharmacy: yup.string().optional(),
  firstName: yup
    .string()
    .matches(/^[A-Za-z\s]+$/)
    .nullable()
    .optional(),
  middleName: yup
    .string()
    .matches(/^[A-Za-z\s]+$/)
    .nullable()
    .optional(),
  lastName: yup
    .string()
    .matches(/^[A-Za-z\s]+$/)
    .nullable()
    .optional(),
  dateOfBirth: yup.date().nullable().optional(),
  gender: yup.string().nullable().optional(),
  address: yup
    .string()
    .matches(/^[A-Za-z0-9\s]+$/)
    .nullable()
    .optional(),
  roomNumber: yup.string().nullable().optional(),
  bedNumber: yup.string().nullable().optional(),
  ssn: yup.string().nullable().optional(),
  admissionType: yup.string().nullable().optional(),
  pcpName: yup.string().nullable().optional(),
  pcpNPI: yup.string().nullable().optional(),
  preferredPharmacy: yup.string().nullable().optional(),

  // Clinical Details
  // admissionDate: yup.date().required('Admission date is required').nullable(),
  // attendingPhysician: yup.string().required('Attending physician is required'),
  // primaryDiagnosis: yup.string().required('Primary diagnosis is required'),
  // sex: yup.string().required('Sex is required'),
  // bloodPressure: yup.string().optional(),
  // height: yup.string().optional(),
  // weight: yup.string().optional(),
  // allergies: yup.array().of(yup.string()).optional(),
  // medicalRecordNumber: yup.string().required('Medical Record Number is required'),
  // mentalCondition: yup.string().optional(),
  // physicalDisabilities: yup.string().optional(),
  admissionDate: yup.date().nullable().optional(),
  attendingPhysician: yup.string().nullable().optional(),
  primaryDiagnosis: yup.string().nullable().optional(),
  sex: yup.string().nullable().optional(),
  bloodPressure: yup.string().nullable().optional(),
  height: yup
    .number()
    .optional()
    .nullable()
    .positive("Height must be positive"),
  weight: yup
    .number()
    .optional()
    .nullable()
    .positive("Weight must be positive"),
  allergies: yup.string().nullable().optional(),

  medicalRecordNumber: yup.string().nullable().optional(),
  mentalCondition: yup.string().nullable().optional(),
  physicalDisabilities: yup.string().nullable().optional(),
  // Insurance Information
  // insuranceCompanyName: yup.string().required('Insurance Company Name is required'),
  // insuranceType: yup.string().required('Insurance Type is required'),
  // payerId: yup.string().required('Payer ID is required'),
  // insurancePhone: yup
  //   .string()
  //   .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit phone number")
  //   .optional(),
  // insuranceEmail: yup.string().email('Invalid email').optional(),
  // subscriberName: yup
  //   .string()
  //   .matches(/^[A-Za-z ]+$/, "Only alphabets are allowed")
  //   .required("Subscriber name is required"),

  // subscriberRelationship: yup.string().required('Relationship is required'),
  // subscriberDob: yup.date().required('Subscriber DOB is required').nullable(),
  // subscriberGender: yup.string().required('Subscriber Gender is required'),
  // subscriberPhone: yup
  //   .string()
  //   .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit phone number")
  //   .required("Subscriber phone is required"),

  // subscriberAddress: yup.string().required('Subscriber Address is required'),
  // subscriberEmployerName: yup.string().optional(),
  // subscriberEmployerAddress: yup.string().optional(),
  insuranceCompanyName: yup.string().nullable().optional(),
  insuranceType: yup.string().nullable().optional(),
  payerId: yup.string().nullable().optional(),

  insurancePhone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit phone number")
    .nullable()
    .optional(),

  insuranceEmail: yup.string().email("Invalid email").nullable().optional(),

  subscriberName: yup
    .string()
    .matches(/^[A-Za-z ]+$/, "Only alphabets are allowed")
    .nullable()
    .optional(),

  subscriberRelationship: yup.string().nullable().optional(),

  subscriberDob: yup.date().nullable().optional(),

  subscriberGender: yup.string().nullable().optional(),

  subscriberPhone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit phone number")
    .nullable()
    .optional(),

  subscriberAddress: yup.string().nullable().optional(),

  subscriberEmployerName: yup.string().nullable().optional(),
  subscriberEmployerAddress: yup.string().nullable().optional(),

  // Policy Details
  policyMemberId: yup.string().required("Policy/Member ID is required"),
  groupNumber: yup.string().optional(),
  planName: yup.string().optional(),
  planType: yup.string().optional(),
  coverageType: yup.string().optional(),
  effectiveDate: yup.date().optional().nullable(),
  endDate: yup.date().optional().nullable(),
  referralRequired: yup.string().optional(),
  priorAuthRequired: yup.string().optional(),
  authorizationNumber: yup.string().optional(),
  copayAmount: yup.string().optional(),
  coinsurance: yup.string().optional(),
  deductible: yup.string().optional(),
  remainingDeductible: yup.string().optional(),
  oopLimit: yup.string().optional(),

  // Billing Fields
  billingProviderNpi: yup.string().optional(),
  billingProviderTaxId: yup.string().optional(),
  billingProviderAddress: yup.string().optional(),
  renderingProviderName: yup.string().optional(),
  renderingProviderNpi: yup.string().optional(),
  facilityNpi: yup.string().optional(),
  posCode: yup.string().optional(),
  icd10Codes: yup.string().optional(),
  cptCodes: yup.string().optional(),
  modifiers: yup.string().optional(),
  chargeAmount: yup.string().optional(),
  claimNotes: yup.string().optional(),
  submissionMethod: yup.string().optional(),

  // Documents
  documentName: yup.string().optional(),
});

type FormData = yup.InferType<typeof admissionSchema>;

interface UploadedDocument {
  id: string;
  name: string;
  fileName: string;
  file: File;
}

const steps = [
  "Personal Information",
  "Clinical Details (Physician Order)",
  "Insurance Information",
  "Upload Documents",
  "Review & Submit",
];

const AdmissionsPage: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState<FormData | null>(null);
  const [admissionSuccess, setAdmissionSuccess] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState<
    UploadedDocument[]
  >([]);
  const [currentDocName, setCurrentDocName] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [personalInfoCompleted, setPersonalInfoCompleted] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { mode = "create", residentId } = location.state || {};
  const isEditMode = mode === "edit";
  const {
    getResidentById,
    updateResident,
    selectedResident,
    loading,
    createResident,
  } = useResidents();

  const [currentFile, setCurrentFile] = useState<File | null>(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    trigger,
    setValue,
  } = useForm<FormData>({
    resolver: yupResolver(admissionSchema),
    defaultValues: {
      allergies: "",
    },
  });

  const stepSchemas = [
    // Step 0: Personal
    [
      "firstName",
      "lastName",
      "dateOfBirth",
      "gender",
      "roomNumber",
      "bedNumber",
      "ssn",
      "admissionType",
      "pcpName",
      "pcpNPI",
      "preferredPharmacy",
    ],
    // Step 1: Clinical
    [
      "admissionDate",
      "attendingPhysician",
      "primaryDiagnosis",
      "sex",
      "bloodPressure",
      "height",
      "weight",
      "allergies",
      "medicalRecordNumber",
      "mentalCondition",
      "physicalDisabilities",
    ],
    // Step 2: Insurance (includes Policy Details and Billing Fields)
    [
      "insuranceCompanyName",
      "insuranceType",
      "payerId",
      "insurancePhone",
      "insuranceEmail",
      "subscriberName",
      "subscriberRelationship",
      "subscriberDob",
      "subscriberGender",
      "subscriberPhone",
      "subscriberAddress",
      "subscriberEmployerName",
      "subscriberEmployerAddress",
      "policyMemberId",
      "groupNumber",
      "planName",
      "planType",
      "coverageType",
      "effectiveDate",
      "endDate",
      "referralRequired",
      "priorAuthRequired",
      "authorizationNumber",
      "copayAmount",
      "coinsurance",
      "deductible",
      "remainingDeductible",
      "oopLimit",
      "billingProviderNpi",
      "billingProviderTaxId",
      "billingProviderAddress",
      "renderingProviderName",
      "renderingProviderNpi",
      "facilityNpi",
      "posCode",
      "icd10Codes",
      "cptCodes",
      "modifiers",
      "chargeAmount",
      "claimNotes",
      "submissionMethod",
    ],
    // Step 3: Upload
    [],
    // Step 4: Review
    [],
  ];

  // REPLACE your entire onSubmit:
  const onSubmit = async () => {
    try {
      // Validate all form fields
      const isValid = await trigger();
      if (!isValid) return;

      const rawData = getValues();

      // Format dates for backend
    const finalData = {
  ...rawData,
  // REQUIRED Backend Fields - Add these defaults
  firstName: rawData.firstName || "John",
  gender: rawData.gender || "Male",
  // careLevel: rawData.careLevel || "MEDIUM",
  attendingPhysicianName: rawData.attendingPhysician || "Dr. Smith",
  emergencyContactName: rawData.subscriberName || "Emergency Contact",
  emergencyContactPhone: rawData.subscriberPhone || "123-456-7890",

  // Date formatting
  dateOfBirth: rawData.dateOfBirth ? format(rawData.dateOfBirth, 'yyyy-MM-dd') : null,
  admissionDate: rawData.admissionDate ? format(rawData.admissionDate, "yyyy-MM-dd'T'HH:mm:ss") : null,

  // Field mapping (keep these)
  insuranceProvider: rawData.insuranceCompanyName,
  insurancePolicyNumber: rawData.policyMemberId,
  insuranceGroupNumber: rawData.groupNumber,
};


      // Clean null/empty values
      const cleanData: any = {};
      Object.entries(finalData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          cleanData[key] = value;
        }
      });

      console.log("🚀 SENDING RESIDENT DATA:", cleanData);

      if (isEditMode && residentId) {
        await updateResident(residentId, cleanData);
        navigate("/residents", { state: { success: "Resident updated!" } });
      } else {
        // ✅ CREATE NEW RESIDENT
        const newResident = await createResident(cleanData);
        console.log("✅ Resident created:", newResident);
        setAdmissionSuccess(true);
        navigate("/residents", {
          state: {
            success: `Resident "${newResident.firstName} ${newResident.lastName}" created!`,
          },
        });
      }
    } catch (error: any) {
      console.error("❌ Submit failed:", error);
      // Set error state (add this state if missing)
      // setError(error.response?.data?.message || 'Failed to create resident');
    }
  };

  useEffect(() => {
    if (selectedResident && isEditMode) {
      // ✅ Uses hook's state
      const formValues = mapResidentToFormData(selectedResident);
      Object.entries(formValues).forEach(([key, value]) => {
        setValue(key as keyof FormData, value);
      });
      setFormData(formValues as FormData);
      setActiveStep(0);
    }
  }, [selectedResident, isEditMode, setValue]);

  const onNext = async () => {
    const fields = stepSchemas[activeStep];
    if (fields.length > 0) {
      const valid = await trigger(fields as any);
      if (!valid) return;
    }

    const currentData = getValues();
    setFormData({ ...formData, ...currentData });

    // Mark personal info as completed when moving past step 0
    if (activeStep === 0) {
      setPersonalInfoCompleted(true);
    }

    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setAdmissionSuccess(false);
    setFormData(null);
    setUploadedDocuments([]);
    setPersonalInfoCompleted(false);
  };
  const handleFileSelect = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      setCurrentFile(file);
    }
  };
  const handleAddDocument = () => {
    if (currentFile && currentDocName) {
      const newDocument: UploadedDocument = {
        id: Date.now().toString(),
        name: currentDocName,
        fileName: currentFile.name,
        file: currentFile,
      };

      setUploadedDocuments([...uploadedDocuments, newDocument]);

      // Clear fields
      setCurrentDocName("");
      setCurrentFile(null);
    }
  };
const mapResidentToFormData = (resident: any): Partial<FormData> => ({
  firstName: resident.firstName || "",
  middleName: resident.middleName || "",
  lastName: resident.lastName || "",
  dateOfBirth: resident.dateOfBirth ? new Date(resident.dateOfBirth) : null,
  gender:
    resident.gender === "MALE"
      ? "male"
      : resident.gender === "FEMALE"
      ? "female"
      : "other",
  address: resident.address || "",
  roomNumber: resident.roomNumber || "",
  bedNumber: resident.bedNumber || "",
  ssn: "",
  admissionType: resident.admissionType || "SNF",
  pcpName: "",
  pcpNPI: "",
  preferredPharmacy: "",

  admissionDate: resident.admissionDate
    ? new Date(resident.admissionDate)
    : null,
  attendingPhysician: resident.attendingPhysicianName || "",
  primaryDiagnosis: resident.primaryDiagnosis || "",
  sex:
    resident.gender === "MALE"
      ? "male"
      : resident.gender === "FEMALE"
      ? "female"
      : "other",
  bloodPressure: "",
  height: null,
  weight: null,
  allergies: resident.allergies || "",
  medicalRecordNumber: resident.medicalRecordNumber || "",
  mentalCondition: "",
  physicalDisabilities: "",

  insuranceCompanyName: resident.insuranceProvider || "",
  insuranceType: "",
  payerId: "",
  insurancePhone: "",
  insuranceEmail: "",
  subscriberName: resident.emergencyContactName || "",
  subscriberRelationship: resident.emergencyContactRelationship || "Self",
  subscriberDob: null,
  subscriberGender: resident.gender?.toLowerCase() || "",
  subscriberPhone: resident.emergencyContactPhone || "",
  subscriberAddress: resident.address || "",
  subscriberEmployerName: "",
  subscriberEmployerAddress: "",

  policyMemberId: resident.insurancePolicyNumber || "",
  groupNumber: resident.insuranceGroupNumber || "",
  planName: "",
  planType: "",
  coverageType: "",
  effectiveDate: null,
  endDate: null,
  referralRequired: "",
  priorAuthRequired: "",
  authorizationNumber: "",
  copayAmount: "",
  coinsurance: "",
  deductible: "",
  remainingDeductible: "",
  oopLimit: "",

  billingProviderNpi: "",
  billingProviderTaxId: "",
  billingProviderAddress: "",
  renderingProviderName: "",
  renderingProviderNpi: "",
  facilityNpi: "",
  posCode: "",
  icd10Codes: "",
  cptCodes: "",
  modifiers: "",
  chargeAmount: "",
  claimNotes: "",
  submissionMethod: "",

  documentName: "",
});


  useEffect(() => {
    if (isEditMode && residentId && !selectedResident) {
      getResidentById(residentId);
    }
  }, [isEditMode, residentId, getResidentById, selectedResident]);

  const handleDeleteDocument = (id: string) => {
    setUploadedDocuments(uploadedDocuments.filter((doc) => doc.id !== id));
  };

  const handleViewDocument = (file: File) => {
    const url = URL.createObjectURL(file);
    window.open(url, "_blank");
  };

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0: // Personal Information
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Controller
                name="firstName"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="First Name"
                    error={!!errors.firstName}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    helperText={errors.firstName?.message}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      field.onChange(value);
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="middleName"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Middle Name"
                    error={!!errors.middleName}
                    helperText={errors.middleName?.message}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      field.onChange(value);
                    }}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="lastName"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Last Name"
                    error={!!errors.lastName}
                    helperText={errors.lastName?.message}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      field.onChange(value);
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  name="dateOfBirth"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      label="Date of Birth"
                      value={field.value}
                      onChange={field.onChange}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: !!errors.dateOfBirth,
                          helperText: errors.dateOfBirth?.message,
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="gender"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.gender}>
                    <InputLabel>Gender</InputLabel>
                    <Select {...field}>
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                    </Select>
                    <FormHelperText>{errors.gender?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="address"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Address"
                    error={!!errors.address}
                    helperText={errors.address?.message}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    onChange={(e) => {
                      const value = e.target.value.replace(
                        /[^A-Za-z0-9\s]/g,
                        ""
                      );
                      field.onChange(value);
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="roomNumber"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Room Number"
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    error={!!errors.roomNumber}
                    helperText={errors.roomNumber?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="bedNumber"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Bed Number"
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    error={!!errors.bedNumber}
                    helperText={errors.bedNumber?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="ssn"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    label="Patient SSN (Optional)"
                    error={!!errors.ssn}
                    helperText={errors.ssn?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="admissionType"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.admissionType}>
                    <InputLabel>Admission Type</InputLabel>
                    <Select {...field}>
                      <MenuItem value="SNF">Skilled Nursing Facility</MenuItem>
                      <MenuItem value="Hospice">Hospice Care</MenuItem>
                    </Select>
                    <FormHelperText>
                      {errors.admissionType?.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="pcpName"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    label="Primary Care Physician (PCP) Name"
                    error={!!errors.pcpName}
                    helperText={errors.pcpName?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="pcpNPI"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    fullWidth
                    label="PCP NPI"
                    error={!!errors.pcpNPI}
                    helperText={errors.pcpNPI?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="preferredPharmacy"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    fullWidth
                    label="Preferred Pharmacy"
                    error={!!errors.preferredPharmacy}
                    helperText={errors.preferredPharmacy?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        );

      case 1: // Clinical Details
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Controller
                name="medicalRecordNumber"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    fullWidth
                    label="Medical Record Number"
                    error={!!errors.medicalRecordNumber}
                    helperText={errors.medicalRecordNumber?.message}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Controller
                name="attendingPhysician"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    label="Attending Physician"
                    error={!!errors.attendingPhysician}
                    helperText={errors.attendingPhysician?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  name="admissionDate"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      label="Admission Date"
                      value={field.value}
                      onChange={field.onChange}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: !!errors.admissionDate,
                          helperText: errors.admissionDate?.message,
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Controller
                name="bloodPressure"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    label="Blood Pressure"
                    error={!!errors.bloodPressure}
                    helperText={errors.bloodPressure?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="height"
                control={control}
                render={({ field: { onChange, value, ...field } }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Height (inches)"
                    type="number" // ✅ CRITICAL: Number input
                    inputProps={{
                      step: "0.1", // ✅ Allow decimals
                      min: "0", // ✅ No negative height
                    }}
                    value={value || ""} // ✅ Handle null/undefined
                    onChange={(e) => {
                      const numValue =
                        e.target.value === ""
                          ? null
                          : parseFloat(e.target.value);
                      onChange(numValue); // ✅ Send number or null
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)",
                      },
                    }}
                    error={!!errors.height}
                    helperText={errors.height?.message || "e.g. 65.5"}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="weight"
                control={control}
                render={(
                  { field: { onChange, value, ...field } } // ✅ Destructure like height
                ) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Weight (lbs)"
                    type="number" // ✅ Add this
                    inputProps={{
                      step: "0.1",
                      min: "0",
                    }}
                    value={value || ""} // ✅ Handle null
                    onChange={(e) => {
                      // ✅ Custom onChange
                      const numValue =
                        e.target.value === ""
                          ? null
                          : parseFloat(e.target.value);
                      onChange(numValue);
                    }}
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.weight}
                    helperText={errors.weight?.message || "e.g. 150.5"}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="allergies"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Allergies (comma-separated)"
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    multiline
                    rows={2}
                    error={!!errors.allergies}
                    helperText={
                      errors.allergies?.message || "e.g. Penicillin, Nuts, Dust"
                    }
                    placeholder="Penicillin, Nuts, Dust"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="primaryDiagnosis"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    fullWidth
                    label="Primary Diagnosis"
                    multiline
                    rows={2}
                    error={!!errors.primaryDiagnosis}
                    helperText={errors.primaryDiagnosis?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="mentalCondition"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    label="Mental Condition"
                    multiline
                    rows={2}
                    error={!!errors.mentalCondition}
                    helperText={errors.mentalCondition?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="physicalDisabilities"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    InputLabelProps={{
                      shrink: true, // ✅ FIX: Force label to float up
                    }}
                    sx={{
                      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                        transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                      },
                    }}
                    label="Physical Disabilities"
                    multiline
                    rows={2}
                    error={!!errors.physicalDisabilities}
                    helperText={errors.physicalDisabilities?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        );

      case 2: // Insurance Information (Combined)
        return (
          <Box>
            {/* Basic Insurance Information */}
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="insuranceCompanyName"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Insurance Company Name"
                      error={!!errors.insuranceCompanyName}
                      helperText={errors.insuranceCompanyName?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="insuranceType"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth error={!!errors.insuranceType}>
                      <InputLabel>Insurance Type</InputLabel>
                      <Select {...field}>
                        <MenuItem value="PRIVATE">Private</MenuItem>
                        <MenuItem value="MEDICAID">Medicaid</MenuItem>
                        <MenuItem value="MEDICARE">Medicare</MenuItem>
                        <MenuItem value="COMMERCIAL">Commercial</MenuItem>
                        <MenuItem value="EMPLOYER_BASED">
                          Employer-Based
                        </MenuItem>
                      </Select>
                      <FormHelperText>
                        {errors.insuranceType?.message}
                      </FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="payerId"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Payer ID"
                      error={!!errors.payerId}
                      helperText={errors.payerId?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="insurancePhone"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Insurance Phone"
                      error={!!errors.insurancePhone}
                      helperText={errors.insurancePhone?.message}
                      inputProps={{ maxLength: 10 }}
                      onChange={(e) => {
                        // allow only numbers
                        const value = e.target.value.replace(/\D/g, "");
                        field.onChange(value);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="insuranceEmail"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Insurance Email"
                      error={!!errors.insuranceEmail}
                      helperText={errors.insuranceEmail?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                  Policyholder / Subscriber Information
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="subscriberName"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Subscriber Name"
                      error={!!errors.subscriberName}
                      helperText={errors.subscriberName?.message}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^A-Za-z ]/g, ""); // only alphabets & spaces
                        field.onChange(value);
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Controller
                  name="subscriberRelationship"
                  control={control}
                  render={({ field }) => (
                    <FormControl
                      fullWidth
                      error={!!errors.subscriberRelationship}
                    >
                      <InputLabel>Relationship to Patient</InputLabel>
                      <Select {...field}>
                        <MenuItem value="Self">Self</MenuItem>
                        <MenuItem value="Spouse">Spouse</MenuItem>
                        <MenuItem value="Child">Child</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                      <FormHelperText>
                        {errors.subscriberRelationship?.message}
                      </FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    name="subscriberDob"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        label="Subscriber DOB"
                        value={field.value}
                        onChange={field.onChange}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: !!errors.subscriberDob,
                            helperText: errors.subscriberDob?.message,
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="subscriberGender"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth error={!!errors.subscriberGender}>
                      <InputLabel>Subscriber Gender</InputLabel>
                      <Select {...field}>
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                      <FormHelperText>
                        {errors.subscriberGender?.message}
                      </FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="subscriberPhone"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      label="Subscriber Phone"
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      error={!!errors.subscriberPhone}
                      helperText={errors.subscriberPhone?.message}
                      inputProps={{ maxLength: 10 }}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // ONLY numbers
                        field.onChange(value);
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Controller
                  name="subscriberAddress"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Subscriber Address"
                      error={!!errors.subscriberAddress}
                      helperText={errors.subscriberAddress?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="subscriberEmployerName"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Subscriber Employer Name"
                      error={!!errors.subscriberEmployerName}
                      helperText={errors.subscriberEmployerName?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="subscriberEmployerAddress"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      InputLabelProps={{
                        shrink: true, // ✅ FIX: Force label to float up
                      }}
                      sx={{
                        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                          transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                        },
                      }}
                      label="Subscriber Employer Address"
                      error={!!errors.subscriberEmployerAddress}
                      helperText={errors.subscriberEmployerAddress?.message}
                    />
                  )}
                />
              </Grid>
            </Grid>

            {/* Policy Details Accordion */}
            <Accordion sx={{ mt: 3 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Policy Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="policyMemberId"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Policy / Member ID"
                          error={!!errors.policyMemberId}
                          helperText={errors.policyMemberId?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="groupNumber"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Group Number"
                          error={!!errors.groupNumber}
                          helperText={errors.groupNumber?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="planName"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Plan Name"
                          error={!!errors.planName}
                          helperText={errors.planName?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="planType"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.planType}>
                          <InputLabel>Plan Type</InputLabel>
                          <Select {...field}>
                            <MenuItem value="HMO">HMO</MenuItem>
                            <MenuItem value="PPO">PPO</MenuItem>
                            <MenuItem value="POS">POS</MenuItem>
                            <MenuItem value="EPO">EPO</MenuItem>
                            <MenuItem value="Medicare Advantage">
                              Medicare Advantage
                            </MenuItem>
                            <MenuItem value="Medicaid Managed Care">
                              Medicaid Managed Care
                            </MenuItem>
                          </Select>
                          <FormHelperText>
                            {errors.planType?.message}
                          </FormHelperText>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="coverageType"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth error={!!errors.coverageType}>
                          <InputLabel>Coverage Type</InputLabel>
                          <Select {...field}>
                            <MenuItem value="MEDICAL">Medical</MenuItem>
                            <MenuItem value="DENTAL">Dental</MenuItem>
                            <MenuItem value="VISION">Vision</MenuItem>
                            <MenuItem value="PHARMACY">Pharmacy</MenuItem>
                            <MenuItem value="BEHAVIORAL_HEALTH">
                              Behavioral Health
                            </MenuItem>
                          </Select>
                          <FormHelperText>
                            {errors.coverageType?.message}
                          </FormHelperText>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Controller
                        name="effectiveDate"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            label="Effective Date"
                            value={field.value}
                            onChange={field.onChange}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errors.effectiveDate,
                                helperText: errors.effectiveDate?.message,
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Controller
                        name="endDate"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            label="End/Termination Date"
                            value={field.value}
                            onChange={field.onChange}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errors.endDate,
                                helperText: errors.endDate?.message,
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="referralRequired"
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          component="fieldset"
                          error={!!errors.referralRequired}
                        >
                          <FormLabel component="legend">
                            Does Policy Require Referral?
                          </FormLabel>
                          <RadioGroup row {...field}>
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                          <FormHelperText>
                            {errors.referralRequired?.message}
                          </FormHelperText>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="priorAuthRequired"
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          component="fieldset"
                          error={!!errors.priorAuthRequired}
                        >
                          <FormLabel component="legend">
                            Does Policy Require Prior Authorization?
                          </FormLabel>
                          <RadioGroup row {...field}>
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                          <FormHelperText>
                            {errors.priorAuthRequired?.message}
                          </FormHelperText>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="authorizationNumber"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Authorization Number (if received)"
                          error={!!errors.authorizationNumber}
                          helperText={errors.authorizationNumber?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="copayAmount"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Copay Amount"
                          error={!!errors.copayAmount}
                          helperText={errors.copayAmount?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="coinsurance"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Coinsurance %"
                          error={!!errors.coinsurance}
                          helperText={errors.coinsurance?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="deductible"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Deductible (Annual)"
                          error={!!errors.deductible}
                          helperText={errors.deductible?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="remainingDeductible"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Remaining Deductible"
                          error={!!errors.remainingDeductible}
                          helperText={errors.remainingDeductible?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="oopLimit"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Out-of-Pocket Limit"
                          error={!!errors.oopLimit}
                          helperText={errors.oopLimit?.message}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/* Claim Processing / Billing Fields Accordion */}
            <Accordion sx={{ mt: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">
                  Claim Processing / Billing Fields
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="billingProviderNpi"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Billing Provider NPI"
                          error={!!errors.billingProviderNpi}
                          helperText={errors.billingProviderNpi?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="billingProviderTaxId"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Billing Provider Tax ID"
                          error={!!errors.billingProviderTaxId}
                          helperText={errors.billingProviderTaxId?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="billingProviderAddress"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Billing Provider Address"
                          error={!!errors.billingProviderAddress}
                          helperText={errors.billingProviderAddress?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="renderingProviderName"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Rendering Provider Name"
                          error={!!errors.renderingProviderName}
                          helperText={errors.renderingProviderName?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="renderingProviderNpi"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Rendering Provider NPI"
                          error={!!errors.renderingProviderNpi}
                          helperText={errors.renderingProviderNpi?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="facilityNpi"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Facility NPI"
                          error={!!errors.facilityNpi}
                          helperText={errors.facilityNpi?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="posCode"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Place of Service (POS Code)"
                          error={!!errors.posCode}
                          helperText={errors.posCode?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="icd10Codes"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="ICD-10 Diagnosis Codes"
                          error={!!errors.icd10Codes}
                          helperText={errors.icd10Codes?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="cptCodes"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="CPT/HCPCS Codes"
                          error={!!errors.cptCodes}
                          helperText={errors.cptCodes?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="modifiers"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Modifiers"
                          error={!!errors.modifiers}
                          helperText={errors.modifiers?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="chargeAmount"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Charge Amount"
                          error={!!errors.chargeAmount}
                          helperText={errors.chargeAmount?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="submissionMethod"
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          fullWidth
                          error={!!errors.submissionMethod}
                        >
                          <InputLabel>Claim Submission Method</InputLabel>
                          <Select {...field}>
                            <MenuItem value="EDI">EDI</MenuItem>
                            <MenuItem value="Portal">Portal</MenuItem>
                            <MenuItem value="Mail">Mail</MenuItem>
                          </Select>
                          <FormHelperText>
                            {errors.submissionMethod?.message}
                          </FormHelperText>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="claimNotes"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          InputLabelProps={{
                            shrink: true, // ✅ FIX: Force label to float up
                          }}
                          sx={{
                            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                              transform: "translate(14px, -9px) scale(0.75)", // ✅ Backup CSS
                            },
                          }}
                          label="Claim Notes"
                          multiline
                          rows={2}
                          error={!!errors.claimNotes}
                          helperText={errors.claimNotes?.message}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Box>
        );

      case 3: // Upload Documents
        return (
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Document Name"
                  value={currentDocName}
                  onChange={(e) => setCurrentDocName(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  sx={{ height: "56px" }}
                >
                  {currentFile ? currentFile.name : "Select File"}
                  <input
                    type="file"
                    id="document-upload"
                    hidden
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setCurrentFile(e.target.files[0]);
                      }
                    }}
                  />
                </Button>
                {selectedFile && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Selected: {selectedFile.name}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ height: "56px" }}
                  onClick={handleAddDocument}
                  disabled={!currentDocName || !currentFile}
                >
                  Add
                </Button>
              </Grid>
            </Grid>

            {uploadedDocuments.length > 0 && (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6" gutterBottom>
                  Uploaded Documents
                </Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Document Name</TableCell>
                        <TableCell>File Name</TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {uploadedDocuments.map((doc) => (
                        <TableRow key={doc.id}>
                          <TableCell>{doc.name}</TableCell>
                          <TableCell>{doc.fileName}</TableCell>
                          <TableCell align="center">
                            <IconButton
                              color="primary"
                              onClick={() => handleViewDocument(doc.file)}
                            >
                              <VisibilityIcon />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={() => handleDeleteDocument(doc.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </Box>
        );

      case 4: // Review & Submit
        const values = getValues();
        return (
          <Box>
            <Typography variant="h6" gutterBottom>
              Please review the information before submitting:
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2">
                  Personal Information:
                </Typography>
                <Typography>
                  {values.firstName} {values.middleName} {values.lastName}
                </Typography>
                <Typography>DOB: {values.dateOfBirth?.toString()}</Typography>
                <Typography>
                  Gender: {values.gender} {values.address}
                </Typography>
                <Typography>
                  Room: {values.roomNumber}, Bed: {values.bedNumber}
                </Typography>
                <Typography>Admission Type: {values.admissionType}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2">Clinical Details:</Typography>
                <Typography>
                  Admission Date: {values.admissionDate?.toString()}
                </Typography>
                <Typography>
                  Attending Physician: {values.attendingPhysician}
                </Typography>
                <Typography>
                  Primary Diagnosis: {values.primaryDiagnosis}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2">
                  Insurance Information:
                </Typography>
                <Typography>Provider: {values.insuranceCompanyName}</Typography>
                <Typography>Policy: {values.policyMemberId}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2">Documents:</Typography>
                <Typography>
                  {uploadedDocuments.length} document(s) uploaded
                </Typography>
              </Grid>
            </Grid>
          </Box>
        );

      default:
        return <div>Unknown step</div>;
    }
  };
  {
    isEditMode && loading && !selectedResident && (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading resident data...</Typography>
      </Box>
    );
  }
  if (admissionSuccess) {
    return (
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Admissions
        </Typography>

        <Paper sx={{ p: 3, textAlign: "center" }}>
          <Alert severity="success" sx={{ mb: 2 }}>
            Resident admission successfully created!
          </Alert>
          <Typography variant="h6" gutterBottom>
            Resident has been admitted to the facility
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            The resident is now in the system and can be managed through the
            Residents section.
          </Typography>
          <Button variant="contained" onClick={handleReset}>
            Add Another Resident
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {isEditMode ? "Edit Resident" : "New Admission"}
      </Typography>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Stepper activeStep={activeStep} alternativeLabel>
            {personalInfoCompleted ? (
              // Show all steps after personal info is completed
              steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))
            ) : (
              // Show only first step initially
              <Step>
                <StepLabel>{steps[0]}</StepLabel>
              </Step>
            )}
          </Stepper>
        </CardContent>
      </Card>
      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {renderStepContent(activeStep)}

          <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 3 }}>
            {activeStep > 0 && (
              <Button onClick={handleBack} sx={{ mr: 1 }}>
                Back
              </Button>
            )}

            <Button
              type="button"
              variant="contained"
              onClick={activeStep === steps.length - 1 ? onSubmit : onNext}
              sx={{ ml: "auto" }}
            >
              {activeStep === steps.length - 1
                ? isEditMode
                  ? "Update Resident"
                  : "Submit Admission"
                : isEditMode
                ? "Save & Next"
                : "Save Next"}
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default AdmissionsPage;
